module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.modalTitle,
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-1"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.type),
      expression: "sanction_outcome.type"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sanction_outcome, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.typeChanged()
      }]
    }
  }, _vm._l((_vm.options_for_types), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                            " + _vm._s(option.display) + "\n                        ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayTabs),
      expression: "displayTabs"
    }]
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.nTab
    }
  }, [_vm._v(_vm._s(_vm.firstTabTitle))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayRemediationActions),
      expression: "displayRemediationActions"
    }],
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.aTab
    }
  }, [_vm._v("Remediation Actions")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.dTab
    }
  }, [_vm._v("Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.nTab
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "identifier"
    }
  }, [_vm._v("Identifier")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sanction_outcome),
      expression: "sanction_outcome"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.identifier),
      expression: "sanction_outcome.identifier"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "identifier",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.sanction_outcome.identifier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "identifier", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Region")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('select', {
    staticClass: "form-control col-sm-9",
    domProps: {
      "value": _vm.sanction_outcome.region_id
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        _vm.sanction_outcome.region_id = $event.target.value;
        _vm.updateDistricts('updatefromUI')
      }
    }
  }, _vm._l((_vm.regions), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                  " + _vm._s(option.name) + "\n                                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("District")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.district_id),
      expression: "sanction_outcome.district_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sanction_outcome, "district_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.availableDistricts), function(option) {
    return _c('option', {
      key: option.district_id,
      domProps: {
        "value": option.district_id
      }
    }, [_vm._v("\n                                  " + _vm._s(option.district_name) + "\n                                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Offence")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sanction_outcome),
      expression: "sanction_outcome"
    }]
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.current_offence),
      expression: "sanction_outcome.current_offence"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.offenceReadonly
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sanction_outcome, "current_offence", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.currentOffenceChanged()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.options_for_offences), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                                            " + _vm._s(option.lodgement_number + ': ' + option.identifier) + "\n                                        ")])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Offender")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [(_vm.sanction_outcome && _vm.sanction_outcome.current_offence && _vm.sanction_outcome.current_offence.offenders) ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.current_offender),
      expression: "sanction_outcome.current_offender"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sanction_outcome, "current_offender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.currentOffenderChanged()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.sanction_outcome.current_offence.offenders), function(offender) {
    return _c('option', {
      key: offender.id,
      domProps: {
        "value": offender
      }
    }, [(offender.person) ? _c('span', [_vm._v("\n                                                " + _vm._s(offender.person.first_name + ' ' + offender.person.last_name + ', DOB:' + offender.person.dob) + "\n                                            ")]) : (offender.organisation) ? _c('span', [_vm._v("\n                                                " + _vm._s(offender.organisation.name + ', ABN: ' + offender.organisation.abn) + "\n                                            ")]) : _vm._e()])
  })], 2)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Vehicle Registration Number")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.registration_number),
      expression: "sanction_outcome.registration_number"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.is_parking_offence,
      "type": "text",
      "name": "registration_number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.sanction_outcome.registration_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "registration_number", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row col-sm-12"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Alleged committed offences")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('datatable', {
    ref: "tbl_alleged_offence",
    attrs: {
      "id": "tbl_alleged_offence",
      "dtOptions": _vm.dtOptionsAllegedOffence,
      "dtHeaders": _vm.dtHeadersAllegedOffence
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Issued on paper?")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.issued_on_paper),
      expression: "sanction_outcome.issued_on_paper"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "id": "issued_on_paper_yes",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.sanction_outcome.issued_on_paper, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.sanction_outcome, "issued_on_paper", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 radio-button-label",
    attrs: {
      "for": "issued_on_paper_yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.issued_on_paper),
      expression: "sanction_outcome.issued_on_paper"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "id": "issued_on_paper_no",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.sanction_outcome.issued_on_paper, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.sanction_outcome, "issued_on_paper", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 radio-button-label",
    attrs: {
      "for": "issued_on_paper_no"
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Paper ID")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.paper_id),
      expression: "sanction_outcome.paper_id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "paper_id",
      "placeholder": "",
      "disabled": !_vm.sanction_outcome.issued_on_paper
    },
    domProps: {
      "value": (_vm.sanction_outcome.paper_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "paper_id", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Paper notice")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "paper_id_notice"
    }
  }, [(_vm.sanction_outcome.issued_on_paper) ? _c('div', {
    staticClass: "col-sm-7"
  }, [_c('filefield', {
    ref: "sanction_outcome_file",
    attrs: {
      "name": "sanction-outcome-file",
      "documentActionUrl": "temporary_document",
      "isRepeatable": true,
      "disabled": !_vm.sanction_outcome.issued_on_paper
    },
    on: {
      "update-temp-doc-coll-id": _vm.setTemporaryDocumentCollectionId
    }
  })], 1) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.aTab
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Action")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_remediation_action.action),
      expression: "current_remediation_action.action"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "add description",
      "id": "sanction-outcome-description"
    },
    domProps: {
      "value": (_vm.current_remediation_action.action)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_remediation_action, "action", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Due Date")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "dueDatePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": _vm.current_remediation_action.due_date
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": !_vm.enableAddActionButton,
      "type": "button",
      "value": "Add"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addRemediationActionClicked()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row col-sm-12"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Remediation Actions")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('datatable', {
    ref: "tbl_remediation_actions",
    attrs: {
      "id": "tbl_remediation_actions",
      "dtOptions": _vm.dtOptionsRemediationActions,
      "dtHeaders": _vm.dtHeadersRemediationActions
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.dTab
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Description")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.description),
      expression: "sanction_outcome.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "add description",
      "id": "sanction-outcome-description"
    },
    domProps: {
      "value": (_vm.sanction_outcome.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "description", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Date of Issue")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "dateOfIssuePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.date_of_issue),
      expression: "sanction_outcome.date_of_issue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY",
      "disabled": !_vm.sanction_outcome.issued_on_paper
    },
    domProps: {
      "value": (_vm.sanction_outcome.date_of_issue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "date_of_issue", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Time of Issue")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "timeOfIssuePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sanction_outcome.time_of_issue),
      expression: "sanction_outcome.time_of_issue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "HH:MM",
      "disabled": !_vm.sanction_outcome.issued_on_paper
    },
    domProps: {
      "value": (_vm.sanction_outcome.time_of_issue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sanction_outcome, "time_of_issue", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.errorResponse) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "white-space": "pre"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.errorResponse)
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.processingDetails) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": ""
    },
    on: {
      "click": _vm.ok
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Adding")]) : _c('span', [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": !_vm.displaySendToManagerButton
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("Send to Manager")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4a254ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/sanction_outcome/sanction_outcome_modal.vue
// module id = 1065
// module chunks = 0